import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Logger } from '@bo-client/core/logger.service';
import { AuthenticationService } from '@bo-client/core/authentication/authentication.service';
import { Observable, Subject } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogSize } from '@bo-client/shared/constants/mat-dialog-size';
import { GenericConfirmationModalComponent } from '@bo-client/shared/modals/generic-confirmation-modal/generic-confirmation-modal.component';
import { takeUntil } from 'rxjs/operators';
import { path } from '@bo-client/shared/constants/path';
import { AuthorizationService } from '@bo-client/core/authorization/authorization.service';

const log = new Logger('RouterGuard');

@Injectable()
export class RouterGuard {
  private compUnsubs$ = new Subject<void>();

  constructor(
    private router: Router,
    private activateRoute: ActivatedRoute,
    private authorizationService: AuthorizationService,
    public matDialog: MatDialog,
    public authenticationService: AuthenticationService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authenticationService.isLoggedIn) {
      // Speichere die ursprüngliche URL inklusive Query-Parameter für die Weiterleitung nach dem Login
      // Verwende state.url, um die vollständige URL mit Query-Parametern zu erhalten
      const redirectUrl = state.url;
      log.info('redirectUrl', redirectUrl);
      if (redirectUrl && !redirectUrl.includes('/login') && !redirectUrl.includes('/logout')) {
        sessionStorage.setItem('redirectUrl', redirectUrl);
      }
      this.router.navigate([this.authorizationService.getLogoutRoute()], {
        replaceUrl: true
      });
    }

    return true;

    const role = next.data['role'];
    if (role.length > 0) {
      for (let i = 0; i < role.length; i++) {
        if (this.authorizationService.hasRole(role[i])) {
          return true;
        }
      }
      this.unauthorizedMessage();
    }
    return false;
  }

  unauthorizedMessage() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'router-guard-unauthorized-message';
    dialogConfig.maxHeight = MatDialogSize.maxHeight;
    dialogConfig.width = MatDialogSize.width;
    dialogConfig.data = {
      title: 'Unauthorized Access',
      message: 'Sie haben keine Berechtigung für den Zugriff auf diese Seite',
      confirmText: 'Ok',
      errorMessage: true
    };
    const modalDialog = this.matDialog
      .open(GenericConfirmationModalComponent, dialogConfig)
      .afterClosed()
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(() => {
        this.router.navigate([this.authorizationService.selectPrefixUrl() + '/' + path.home], {
          replaceUrl: true
        });
        this.unsubscribeSubscription();
      });
  }

  unsubscribeSubscription() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
